export default "__VITE_ASSET__GL2lbINs__"